import React from 'react'
import { useState } from 'react';
import Page from '../../../../ui/Page'
import { Button, Card, Modal, Table, Typography } from 'antd'
import { DownloadOutlined, FileDoneOutlined, InfoCircleOutlined } from '@ant-design/icons';

const DocumentSignaturePage = () => {
    const PUBLIC_URL = process.env.PUBLIC_URL;
    const [isDetailsModalVisible, setDetailsModalVisible] = useState(false);
    const [isSignaturesModalVisible, setSignaturesModalVisible] = useState(false);

    const showDetailsModal = () => setDetailsModalVisible(true);
    const hideDetailsModal = () => setDetailsModalVisible(false);

    const showSignaturesModal = () => setSignaturesModalVisible(true);
    const hideSignaturesModal = () => setSignaturesModalVisible(false);


    return (
        <Page>
            <div style={{ maxWidth: "940px", margin: "0 auto", textAlign: "center" }}>
                <img
                    src={`${PUBLIC_URL}/assets/color-aitu-logo.svg`}
                    alt="logo"
                    width={160}
                    draggable="false"

                />

                <Typography.Title level={2} style={{ marginTop: 20, marginBottom: 0, color: "#083C60", fontWeight: 700, userSelect: "none" }}>
                    СТРАНИЦА ПРОСМОТРА ДОКУМЕНТА
                </Typography.Title>
                <Typography.Paragraph >document.docx</Typography.Paragraph>

                <div className="content-wrapper" style={{ display: "flex", justifyContent: "space-between", padding: "25px 0px", }}>
                    <div style={{ maxWidth: "410px", textAlign: "justify", marginRight: "20px" }}>
                        <Typography.Paragraph>
                            Это страница просмотра вашего документа, которая на основе его статуса предоставляет
                            вам необходимые функции для удобной работы с ним. Здесь вы можете ознакомиться с
                            подробной информацией о документе, проверить его подлинность, а также скачать или
                            просмотреть оригинальный файл.
                        </Typography.Paragraph>
                        <Typography.Paragraph>
                            Данный документ подписан с использованием электронной подписи. Здесь представлена
                            информация о подписантах и статусе подписи.
                        </Typography.Paragraph>
                    </div>


                    <Card
                        style={{
                            maxWidth: 410,
                            backgroundColor: "#083C60",
                            color: "white",
                            borderRadius: "19px",
                        }}
                    >
                        <Typography.Title level={3} style={{ color: "white", textAlign: "center", marginBottom: "20px" }}>
                            ДЕЙСТВИЯ С ДОКУМЕНТОМ
                        </Typography.Title>
                        <Button type="primary" icon={<InfoCircleOutlined />} block style={{ marginBottom: 22, backgroundColor: "#1E90FF" }} onClick={showDetailsModal}>
                            ДЕТАЛИ ДОКУМЕНТА
                        </Button>
                        <Button type="primary" icon={<DownloadOutlined />} block style={{ marginBottom: 22, backgroundColor: "#1E90FF" }}>
                            СКАЧАТЬ ДОКУМЕНТ
                        </Button>
                        <Button type="primary" icon={<FileDoneOutlined />} block style={{ backgroundColor: "#1E90FF" }} onClick={showSignaturesModal}>
                            ПОКАЗАТЬ ПОДПИСИ
                        </Button>
                    </Card>
                </div>

                <iframe
                    src="https://axiomabio.com/pdf/test.pdf"
                    width="940px"
                    height="800px"
                    className="pdf-viewer"
                    style={{ border: "1px solid #ddd", marginTop: "20px" }}
                ></iframe>
            </div>
            <Modal title="ДЕТАЛИ ДОКУМЕНТА" open={isDetailsModalVisible} onCancel={hideDetailsModal} footer={null}>
                <Table
                    dataSource={[
                        { key: 1, name: 'Название документа', value: 'document.docx' },
                        { key: 2, name: 'Номер документа', value: '567894' },
                        { key: 3, name: 'Дата подписания', value: '20.03.2025, 15:47' },
                        { key: 4, name: 'Статус подписи', value: 'Подписано 3 из 3' },
                        { key: 5, name: 'Формат', value: '.docx' },
                    ]}
                    columns={[
                        { title: '', dataIndex: 'name', key: 'name' },
                        { title: '', dataIndex: 'value', key: 'value' },
                    ]}
                    showHeader={false}
                    pagination={false}

                    size="small"
                    bordered
                />
            </Modal>
            <Modal title="ИНФОРМАЦИЯ О ПОДПИСЯХ ДОКУМЕНТА №567894" open={isSignaturesModalVisible} onCancel={hideSignaturesModal} footer={null}>
                <Typography.Paragraph>
                    <b>Подписант №1:</b><br />
                    <b>ФИО:</b> Тестов Тест Тестович<br />
                    <b>ИНН:</b> 870211111111<br />
                    <b>Должность:</b> Генеральный директор<br />
                    <b>Организация:</b> ТОО "Astana IT University" (БИН 190240014589)<br />
                    <b>Дата подписи:</b> 20.03.2025, 15:40<br />
                    <b>Сертификат:</b> 78A4-BC92-5D67<br />
                    <a href="#">Сведения по ЭЦП</a>
                </Typography.Paragraph>

                <Typography.Paragraph>
                    <b>Подписант №2:</b><br />
                    <b>ФИО:</b> Тестов Тест Тестович<br />
                    <b>ИНН:</b> 870211111111<br />
                    <b>Должность:</b> Финансовый директор<br />
                    <b>Дата подписи:</b> 20.03.2025, 15:42<br />
                    <b>Сертификат:</b> 9B8D-C5F1-7A23<br />
                    <a href="#">Сведения по ЭЦП</a>
                </Typography.Paragraph>

                <Typography.Paragraph>
                    <b>Подписант №3:</b><br />
                    <b>ФИО:</b> Тестов Тест Тестович<br />
                    <b>ИНН:</b> 870211111111<br />
                    <b>Должность:</b> Юрист<br />
                    <b>Дата подписи:</b> 20.03.2025, 15:47<br />
                    <b>Сертификат:</b> 3D1F-8E76-4A95<br />
                    <a href="#">Сведения по ЭЦП</a>
                </Typography.Paragraph>
            </Modal>

            <style>
                {`
          


          @media (max-width: 980px) {
            .pdf-viewer {
              width: 100%;
              height: 600px;
            }
          }


          @media (max-width: 768px) {
            .content-wrapper {
              flex-direction: column;
              align-items: center;
            }
          }

          
          }
        `}
            </style>
        </Page>

    );
}

export default DocumentSignaturePage;